import moment from 'moment';

function createError(instance, error) {
  const text = (error.message)
    || (error.response && error.response.data && error.response.data.message)
    || (error.response && error.response.data && error.response.data.exception_message);

  instance.create({
    delayToClose: false,
    text,
    textAction: 'Close',
    type: 'danger',
  });
}

const actions = {
  setPreRegister({ commit, state, rootState }) {
    const api = rootState.Setup.apiInstance;
    let number = state.data.taxNumber;
    number = number.match(/(^\w{2})|([^$]+)$/gi);

    if (number === null || (number && number.length < 2)) {
      return Promise.resolve();
    }
    const serviceCode = state.data.country.code;
    return api.getCompanyPreRegister(number[1], number[0], serviceCode)
      .then((e) => {
        commit('countryCode', number[0]);
        commit('fiscalNumber', number[1]);
        commit('extraFields', e.data.extra_fields);
        commit('legalForms', e.data.legal_forms);
        commit('sectorEntities', e.data.sector_of_entities);
        commit('taxError', null);
      }).catch((e) => {
        // Fix endpoint bug: When data is a string it's because
        // endpoint returns HTML. We have to change that
        // for a message
        if (typeof e.response.data === 'string') {
          e.response.data = { message: 'Error' };
        }

        throw e;
      });
  },
  setLegalDocuments({ commit, state, rootState }, { locale }) {
    const api = rootState.Setup.apiInstance;

    api.getLegalDocuments(
      state.info.csOperator,
      locale,
    ).then((response) => {
      if (response.data.generic) {
        commit('legalDocumentsGeneric', response.data.generic);
      }
      if (response.data.cs_operator) {
        commit('legalDocumentsOperator', response.data.cs_operator.document);
      }
    }).catch((error) => {
      createError(state.notificationInstance, error);
    });
  },
  setCountry({ commit, dispatch }, { country, locale }) {
    // When a country is set, we set the Operator and the legal document of it.
    commit('country', country);
    commit('csOperator', country.default_cs_operator_uuid);
    dispatch('setLegalDocuments', locale);
  },
  linkUserCompany({
    state,
    commit,
    getters,
    rootState,
  }, { locale }) {
    const api = rootState.Setup.apiInstance;

    const { data } = state.data;
    let fiscalNumber = data.fiscal_number;
    if (localStorage.getItem('env_test')) {
      fiscalNumber = Math.floor(Math.random() * 999999999) + 1;
    }
    const adminIdBase64 = data.adminIDBase64 && data.adminIDBase64.replace(/^.*?base64,/g, '');
    const { incorporationProofBase64 } = data.incorporationProofBase64;
    const proofIncorporationBase64 = incorporationProofBase64 && incorporationProofBase64.replace(/^.*?base64,/g, '');

    const params = {
      commercial_name: data.companyName,
      fiscal_name: data.companyName,
      address: data.companyAddress.address,
      address_details: data.extraCompanyAddress,
      country_code: data.country_code,
      fiscal_number: fiscalNumber,
      phone_1: data.workPhoneNumber,
      size: data.companySize.value,
      legal_form: data.legalForm,
      legal_document_uuids: getters.getLegalUuids,
      sector_of_entities: data.sectorEntity.internal_name,
      email: data.workEmail,
      language: locale,
      admin_id: adminIdBase64,
      birthday: moment(data.datebirth).format('DD/MM/YYYY'),
      proof_of_incorporation: proofIncorporationBase64,
      allow_direct_marketing: !!data.marketingTerms,
    };

    return api.linkExistingUser(params, state.linkAccount.idpUuid).then((response) => {
      commit('companyCreated', true);
      return response;
    }).catch((error) => {
      createError(state.notificationInstance, error);
    });
  },
  createCompany({
    state,
    getters,
    commit,
    rootState,
  }) {
    const api = rootState.Setup.apiInstance;

    const { data } = state;
    let fiscalNumber = data.fiscal_number;
    if (localStorage.getItem('env_test')) {
      fiscalNumber = Math.floor(Math.random() * 999999999) + 1;
    }

    const adminIdBase64 = data.adminIDBase64 && data.adminIDBase64.replace(/^.*?base64,/g, '');
    const { incorporationProofBase64 } = data.incorporationProofBase64;
    const proofIncorporationBase64 = incorporationProofBase64 && incorporationProofBase64.replace(/^.*?base64,/g, '');

    const params = {
      address: data.companyAddress.address,
      address_details: data.extraCompanyAddress,
      commercial_name: data.companyName,
      country_code: data.country_code,
      email: data.companyEmail,
      fiscal_name: data.companyName,
      fiscal_number: fiscalNumber,
      first_name: data.firstName,
      last_name: data.lastName,
      legal_form: data.legalForm,
      password: data.password,
      phone_1: data.phoneNumber,
      service_country_code: data.country.code,
      size: data.companySize.value,
      sector_of_entities: data.sectorEntity.internal_name,
      title: data.title.internal_name,
      admin_id: adminIdBase64,
      proof_of_incorporation: proofIncorporationBase64,
      allow_direct_marketing: !!data.marketingTerms,
      legal_document_uuids: getters.getLegalUuids,
      birthday: moment(data.datebirth).format('DD/MM/YYYY'),
      service: 'rh',
    };

    if (data.country_code === 'IT') {
      Object.assign(params, {
        admin_fiscal_number: data.adminFiscalNumber,
        admin_country_code: data.adminCountryCode,
      });
    }
    if (data.country_code === 'FR') {
      Object.assign(params, {
        siret: data.siret,
      });
    }

    return api.createCompany(params).then((response) => {
      commit('companyCreated', true);
      return response;
    }).catch((error) => {
      createError(state.notificationInstance, error);
    });
  },
};
export default actions;
